// No `toJSON()`: a DELETE carries no body.
class RemoveFacilityTemplateOverride {
	constructor(
		public readonly organizationId: number,
		public readonly overrideId: number,
	) {
		Object.freeze(this);
	}
}

export default RemoveFacilityTemplateOverride;
